module.exports = __webpack_public_path__ + "static/media/python.989372cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/python.png
// module id = 619
// module chunks = 147